import gsap from 'gsap'
import { lenis } from './lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { GSDevTools } from "gsap/GSDevTools"

gsap.registerPlugin(ScrollTrigger, SplitText, GSDevTools)

gsap.config({
  // nullTargetWarn: false
})

export let initAnimations, animParallaxFooter, animAbout, animBannerSpring, animTextBlock

initAnimations = () => {
	animBannerSpring()
	animParallaxFooter()
	animAbout()
	animTextBlock() 
}

animParallaxFooter = () => {
  const footer = document.querySelector('.footer')
  const inner = footer.querySelector('.container')

  if (window.innerWidth <= 1024) return

  gsap.fromTo(inner, {
		yPercent: -32,
		scale: 1
	}, {
		scrollTrigger: {
			trigger: footer,
			start: 'top bottom',
			end: 'bottom bottom',
			scrub: true
		},
		yPercent: 0,
		scale: 1
	})
}

animAbout = () => {
	const about = document.querySelector('.about-panel__inner')

	if (!about) return

	gsap.fromTo(about, {
		scale: 1.2
	}, {
		scale: 1,
		ease: 'power2.out',
		scrollTrigger: {
			trigger: about,
			start: 'top bottom',
			end: 'center center',
			scrub: true
		}
	})
}

animBannerSpring = () => {
	const banners = document.querySelectorAll('.banner-spring')

	banners.forEach(banner => {
		const videos = banner.querySelectorAll('.banner-spring__intro')
		const content = banner.querySelector('.banner-spring__content')
		const text = banner.querySelectorAll('.banner-spring__heading, .banner-spring__subheading, .banner-spring__text')
		const button = banner.querySelector('.banner-spring__button')
		const smallText = banner.querySelector('.banner-spring__small-text')
		const videoAfterDoor = banner.querySelector('.banner-spring__video')

		const split = SplitText.create(text, {
			type: 'lines',
			linesClass: 'line++',
			mask: 'lines'
		})

		const timeline = gsap.timeline({ paused: true })

		videos.forEach(video => {
			video.addEventListener('ended', () => timeline.play())
		})

		console.log('animBannerSpring started')

		timeline.fromTo(content, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.4,
			ease: 'power1.inOut'
		})

		timeline.fromTo([split.lines], {
			y: '130%',
		}, {
			y: '0%',
			duration: 2,
			stagger: 0.1,
			ease: 'expo.out',
		}, '-=0.4')

		if (button && smallText) {
			timeline.fromTo([button, smallText], {
				y: 50,
				opacity: 0,
			}, {
				y: 0,
				opacity: 1,
				stagger: 0.1,
				duration: 0.8,
				ease: 'power2.out'
			}, '-=1.85')
		}

		timeline.to(videos, {
			duration: 1,
			opacity: 0,
			ease: 'power1.inOut',
			onComplete: () => {
				videos.forEach(video => video.remove())
			}
		}, 0)

		timeline.add(() => {
			videoAfterDoor.play()
			console.log('videoAfterDoor', videoAfterDoor)
		}, 0)

		// GSDevTools.create({ animation: timeline })
	})
}

animTextBlock = () => {
	const textBlocks = document.querySelectorAll('.text-block')

	textBlocks.forEach(textBlock => {
		const content = textBlock.querySelector('.text-block__content')
		const heading = textBlock.querySelector('.text-block__heading')
		const text = textBlock.querySelector('.text-block__text')
		const button = textBlock.querySelector('.text-block__button')
		const video = textBlock.querySelector('.text-block__video')

		if (!video || window.innerWidth <= 1024) return

		const split = SplitText.create(heading, {
			type: 'lines',
			linesClass: 'line++',
			mask: 'lines'
		})

		const timeline = gsap.timeline({ paused: true })

		let hasPlayedTimeline = false
		const onVideoTimeUpdate = () => {
			if (hasPlayedTimeline) return
			if (video.currentTime >= 2) {
				hasPlayedTimeline = true
				video.removeEventListener('timeupdate', onVideoTimeUpdate)
				timeline.play()
			}
		}
		video.addEventListener('timeupdate', onVideoTimeUpdate)
		onVideoTimeUpdate()

		timeline.fromTo(content, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.4,
			ease: 'power1.inOut'
		})

		timeline.fromTo([split.lines], {
			y: '130%',
		}, {
			y: '0%',
			duration: 2,
			stagger: 0.1,
			ease: 'expo.out',
		}, '-=0.4')

		if (button && text) {
			timeline.fromTo([text, button], {
				y: 50,
				opacity: 0,
			}, {
				y: 0,
				opacity: 1,
				stagger: 0.1,
				duration: 0.8,
				ease: 'power2.out'
			}, '-=1.85')
		}
	})
}

export default () => { }